import gettext from '@sdk/lang/gettext';
import useConfig from '@sdk/config/useConfig';
import { PosIntegrations, SupportedIntegrationsWithBrands } from '@sdk/integrations/types';

type CodeConnectDetails = {
  description: string;
  connectUrl?: string;
  learnMoreUrl?: string;
};

const useCodeConnectIntegrations = (
  integrationType: SupportedIntegrationsWithBrands
): CodeConnectDetails | null => {
  const { TOAST_LEARN_MORE_URL } = useConfig();

  switch (integrationType) {
    case PosIntegrations.toast:
      return {
        description: gettext(
          'Head to Toast and paste the partner group ID below under the location you want to connect to Sling.'
        ),
        learnMoreUrl: TOAST_LEARN_MORE_URL,
      };
  }

  return null;
};

export default useCodeConnectIntegrations;
